export default __webpack_public_path__ + "static/media/cronos-disable.bb93ab68.svg";